export default __webpack_public_path__ + "static/media/dropdownArrowBlack.38def97e.svg";